module.exports = __webpack_public_path__ + "static/media/generic.c59d8969.svg";